import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { SelectEvent } from "@progress/kendo-angular-layout";
import { BroadcastService } from "src/app/services/broadcast.service";
import { IdentityRolesService } from "src/app/services/identity-roles.service";
import { BaseComponent } from "../../shared/base/base.component";
import { warningZoneArgs } from "./warning-zone/warning-zone.component";
import { CyberArkService } from "src/app/services/cyberark.service";

@Component({
    selector: "app-home",
    templateUrl: "./home.component.html",
    styleUrls: ["./home.component.scss"],
    standalone: false
})
export class HomeComponent extends BaseComponent implements OnInit {
  public warningZoneOpened = false;
  public warningText: string = "";
  isSgProduct: boolean = false;
  isHkProduct: boolean = true; //todo: bug when back from proposal page; temp set to HK
  private googleMapKey: string | null = null;


  constructor(
    public override router: Router,
    public override broadcastService: BroadcastService,
    public override identityRolesService: IdentityRolesService,
    private cyberArkService : CyberArkService
  ) {
    super(router, broadcastService, identityRolesService);

    this.broadcastService.onRoleSet.subscribe((msg: any) => {
      this.setCountry();
    });
  }

  private setCountry() {
    if (this.identityRolesService.IsHASEUser) {
      this.isSgProduct = false;
      this.isHkProduct = true;
    } else {
      this.isSgProduct = true;
      this.isHkProduct = false;
    }
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if(this.googleMapKey != ''){
      this.getGoogleMapKey(); 
    }
  }

  public onTabSelect(e: SelectEvent) {}

  showWarningZoneEvent(args: warningZoneArgs) {
    if (args.showWarning) {
      this.warningZoneOpened = true;
      this.warningText = args.warningText;
    } else {
      this.warningZoneOpened = false;
    }
  }

  getGoogleMapKey(): void {
          this.cyberArkService.getCyberArkKeyvalue().subscribe(
              (keyValue) => {
                  if(keyValue && keyValue != ''){
                    this.googleMapKey = keyValue;  
                  const isMyScriptLoaded = (url: string) => {
                  var scripts = document.getElementsByTagName("script");
                  for (var i = scripts.length; i--; ) {
                    if (scripts[i].src == url) return true;
                      }
                      return false;
                  };  
                  const s = document.createElement("script");
                  s.src ="https://maps.googleapis.com/maps/api/js?key=" +
                          this.googleMapKey +
                          "&callback=Function.prototype&libraries=places&language=en";
  
                  if (!isMyScriptLoaded(s.src)) {
                  const head = document.getElementsByTagName("head")[0];
                  head.appendChild(s);
                 }
                }
              },
              (err) => {
                  console.error(err);
              }
          );
      }
}
